import script from "./ServicesItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServicesItem.vue?vue&type=script&setup=true&lang=ts"

import "./ServicesItem.vue?vue&type=style&index=0&id=bb40d534&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb40d534"]])

export default __exports__